function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button:not(.localization-selector)').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.querySelector('.announcement-bar-slider')) {
      this.announcementBarArrowButtonWasClicked = false;

      this.desktopLayout = window.matchMedia('(min-width: 750px)');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

      [this.reducedMotion, this.desktopLayout].forEach((mediaQuery) => {
        mediaQuery.addEventListener('change', () => {
          if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
        });
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener('click', () => {
          this.announcementBarArrowButtonWasClicked = true;
        }, {once: true});
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked || !this.desktopLayout.matches ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked && this.desktopLayout.matches) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.querySelector('.announcement-bar-slider').contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    const variantGallery = mediaGalleries[0]?.hasAttribute('data-variant-gallery');

    if (variantGallery) {
      this.updateVariantGallery();
      return;
    }

    if (!this.currentVariant.featured_media) return;

    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    if (newMediaModal) modalContent.prepend(newMediaModal);
  }

  getVariantGalleryMap(sectionId) {
    const mapElement = document.getElementById(`VariantGalleryMap-${sectionId}`);
    if (!mapElement) return {};
    try {
      return JSON.parse(mapElement.textContent);
    } catch {
      return {};
    }
  }

  updateVariantGallery() {
    const variantId = String(this.currentVariant.id);
    const sectionId = this.dataset.section;
    const galleryMap = this.getVariantGalleryMap(sectionId);
    const useMetafieldGallery = galleryMap[variantId] === true;
    const isHybrid = document.querySelector(
      `[id^="MediaGallery-${sectionId}"][data-variant-gallery-hybrid]`
    );

    document.querySelectorAll(`[id^="MediaGallery-${sectionId}"][data-variant-gallery]`).forEach((mediaGallery) => {
      const defaultSlides = mediaGallery.querySelectorAll('[data-default-gallery-slide]');
      const defaultThumbs = mediaGallery.querySelectorAll('[data-default-gallery-thumb]');
      const metafieldSlides = mediaGallery.querySelectorAll('[data-variant-gallery-slide]');
      const metafieldThumbs = mediaGallery.querySelectorAll('[data-variant-gallery-thumb]');

      if (isHybrid && !useMetafieldGallery) {
        metafieldSlides.forEach((slide) => slide.classList.add('variant-gallery--hidden'));
        metafieldThumbs.forEach((thumb) => thumb.classList.add('variant-gallery--hidden'));
        defaultSlides.forEach((slide) => slide.classList.remove('variant-gallery--hidden'));
        defaultThumbs.forEach((thumb) => thumb.classList.remove('variant-gallery--hidden'));

        mediaGallery.querySelectorAll('.thumbnail-list__item button[aria-current]').forEach((button) => {
          button.removeAttribute('aria-current');
        });
        const firstDefaultThumb = mediaGallery.querySelector(
          '[data-default-gallery-thumb]:not(.variant-gallery--hidden) button'
        );
        if (firstDefaultThumb) firstDefaultThumb.setAttribute('aria-current', 'true');

        if (this.currentVariant.featured_media && typeof mediaGallery.setActiveMedia === 'function') {
          mediaGallery.setActiveMedia(`${sectionId}-${this.currentVariant.featured_media.id}`, true);
        }

        const defaultCount = parseInt(mediaGallery.dataset.defaultMediaCount, 10) || defaultSlides.length;
        const counter = mediaGallery.querySelector('[data-gallery-counter-total]');
        if (counter) counter.textContent = defaultCount;
        return;
      }

      if (isHybrid) {
        defaultSlides.forEach((slide) => slide.classList.add('variant-gallery--hidden'));
        defaultThumbs.forEach((thumb) => thumb.classList.add('variant-gallery--hidden'));
      }

      let firstVisibleSlide = null;
      metafieldSlides.forEach((slide) => {
        const show = slide.dataset.variantId === variantId;
        slide.classList.toggle('variant-gallery--hidden', !show);
        if (show && !firstVisibleSlide) firstVisibleSlide = slide;
      });

      mediaGallery.querySelectorAll('.thumbnail-list__item button[aria-current]').forEach((button) => {
        button.removeAttribute('aria-current');
      });

      metafieldThumbs.forEach((thumb) => {
        const show = thumb.dataset.variantId === variantId;
        thumb.classList.toggle('variant-gallery--hidden', !show);
      });

      const firstVisibleThumb = mediaGallery.querySelector(
        `[data-variant-gallery-thumb][data-variant-id="${variantId}"]:not(.variant-gallery--hidden) button`
      );
      if (firstVisibleThumb) firstVisibleThumb.setAttribute('aria-current', 'true');

      if (firstVisibleSlide && typeof mediaGallery.setActiveMedia === 'function') {
        mediaGallery.setActiveMedia(firstVisibleSlide.dataset.mediaId, true);
      }

      const metafieldCount = mediaGallery.querySelectorAll(
        `[data-variant-gallery-slide][data-variant-id="${variantId}"]:not(.variant-gallery--hidden)`
      ).length;
      const counter = mediaGallery.querySelector('[data-gallery-counter-total]');
      if (counter) counter.textContent = metafieldCount;
    });

    const modalContent = document.querySelector(`#ProductModal-${sectionId} .product-media-modal__content`);
    if (!modalContent) return;

    if (isHybrid && !useMetafieldGallery) {
      modalContent.querySelectorAll('[data-variant-gallery-modal]').forEach((item) => {
        item.classList.add('variant-gallery--hidden');
      });
      modalContent.querySelectorAll('[data-default-gallery-modal]').forEach((item) => {
        item.classList.remove('variant-gallery--hidden');
      });
      const firstDefaultModal = modalContent.querySelector(
        '[data-default-gallery-modal]:not(.variant-gallery--hidden)'
      );
      if (firstDefaultModal) modalContent.prepend(firstDefaultModal);
      return;
    }

    modalContent.querySelectorAll('[data-default-gallery-modal]').forEach((item) => {
      item.classList.add('variant-gallery--hidden');
    });

    modalContent.querySelectorAll('[data-variant-gallery-modal]').forEach((item) => {
      item.classList.toggle('variant-gallery--hidden', item.dataset.variantId !== variantId);
    });

    const firstModalItem = modalContent.querySelector(
      `[data-variant-gallery-modal][data-variant-id="${variantId}"]:not(.variant-gallery--hidden)`
    );
    if (firstModalItem) modalContent.prepend(firstModalItem);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination)
          inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


/* B+B Legacy scripts */

/*
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie=function(b,j,m){if(typeof j!="undefined"){m=m||{};if(j===null){j="";m.expires=-1}var e="";if(m.expires&&(typeof m.expires=="number"||m.expires.toUTCString)){var f;if(typeof m.expires=="number"){f=new Date();f.setTime(f.getTime()+(m.expires*24*60*60*1000))}else{f=m.expires}e="; expires="+f.toUTCString()}var l=m.path?"; path="+(m.path):"";var g=m.domain?"; domain="+(m.domain):"";var a=m.secure?"; secure":"";document.cookie=[b,"=",encodeURIComponent(j),e,l,g,a].join("")}else{var d=null;if(document.cookie&&document.cookie!=""){var k=document.cookie.split(";");for(var h=0;h<k.length;h++){var c=jQuery.trim(k[h]);if(c.substring(0,b.length+1)==(b+"=")){d=decodeURIComponent(c.substring(b.length+1));break}}}return d}};

var cookieName = window.location.hostname.replace(/-/g, "_").replace(/\./g, "_");

/* jquery  */
$(function() {

  // Check querystring for users from German/French that want to shop EU, and set cookie
  if (window.location.search.indexOf("shop-eu=true") > -1) {
    $.cookie(cookieName, 'true', { expires: 1 });
  }

  var USAArray = ["USA","US"];
  var CAArray = ["CA"];
  var UKArray = ["UK","GB"];
  var EUArray = ["EU","AU","BE","BG","HR","CY","CZ","DK","EE","FI","GR","HU","IE","IT","LV","LT","LU","MT","NL","PL","PT","RO","SK","SI","ES","SE","CH"];
  var DEArray = ["DE"];
  var FRArray = ["FR"];
  var currentSite = window.location.href;

  var isDisplayCountry = $.cookie(cookieName);
  if (!isDisplayCountry) {
    
    jQuery.ajax({ 
      url: 'https://reallyfreegeoip.org/json/?callback=?',
      type: 'POST', 
      dataType: 'jsonp',
      success: function(location) { 
        //CHECK EU SITE
        if ((currentSite.indexOf("blackblum-europe.myshopify.com") > -1 || currentSite.indexOf("black-blum.eu") > -1) && !currentSite.match(/\/fr(\/|$)/) ) {
   
          if (jQuery.inArray(location.country_code, EUArray) > -1) {
            
          }
          else if (jQuery.inArray(location.country_code, USAArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","https://blackblum.com/");
            $(".popup-a-data").html("VISIT OUR US SITE");
            $(".popup-p-data").html("Looks like you’re in<br class='m'>  the United States.<br class='d'> Click below to shop<br class='m'> in your store.");

          }
          else if (jQuery.inArray(location.country_code, CAArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","http://black-blum.ca");
            $(".popup-a-data").html("VISIT CANADIAN SITE");
            $(".popup-p-data").html("Looks like you’re in Canada.<br> Click below to visit our official distributor.");

          }
          else if (jQuery.inArray(location.country_code, UKArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","https://black-blum.com");
            $(".popup-a-data").html("VISIT OUR UK SITE");
            $(".popup-p-data").html("Looks like you’re in<br class='m'> The United Kingdom.<br class='d'> Click below to shop<br class='m'> in your store.");

          }
          else if (jQuery.inArray(location.country_code, DEArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","https://black-blum.de");
            $(".popup-a-data").html("GERMAN SITE");

            $(".popup-a-data-2").attr("style", "display:block");
            $(".popup-a-data-2").attr("href","https://black-blum.eu?shop-eu=true");
            $(".popup-a-data-2").html("EU SITE");

            $(".popup-p-data").html("Looks like you’re in Germany. Click below to shop in your store or shop our EU site to continue in English.");

          }
          else if (jQuery.inArray(location.country_code, FRArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","https://black-blum.eu/fr");
            $(".popup-a-data").html("EU - FRENCH SITE");

            $(".popup-a-data-2").attr("style", "display:block");
            $(".popup-a-data-2").attr("href","https://black-blum.eu?shop-eu=true");
            $(".popup-a-data-2").html("EU - ENGLISH SITE");

            $(".popup-p-data").html("Looks like you’re in France. Click below to shop in your store or shop our EU site to continue in English.");

          }
          else {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("style", "display:none");
            $(".popup-b-data").attr("style", "display:block");
           
            $(".popup-p-data").html("SADLY, WE DON'T SHIP TO YOUR COUNTRY");
            $(".popup-b-data").html("WE SELL OUR DESIGNS IN OVER 60 COUNTRIES, SO PLEASE LOOK ONLINE TO FIND A LOCAL STOCKIST OR ONLINE RETAILER.");
            $(".msg").addClass("msg-div");

          }

        }
        //CHECK USA SITE
        else if (currentSite.indexOf("blackblum.com") > -1 || currentSite.indexOf("blackblum-usa.myshopify.com") > -1) {

          if(jQuery.inArray(location.country_code, USAArray) > -1) {
            
          }
          else if (jQuery.inArray(location.country_code, CAArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","http://black-blum.ca");
            $(".popup-a-data").html("VISIT CANADIAN SITE");
            $(".popup-p-data").html("Looks like you’re in Canada.<br> Click below to visit our official distributor.");

          }
          else if (jQuery.inArray(location.country_code, EUArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","https://black-blum.eu/");
            $(".popup-a-data").html("VISIT OUR EU SITE");
            $(".popup-p-data").html("Looks like you’re in Europe.<br class='d'> Click below to shop<br class='m'> in your store.");

          }
          else if (jQuery.inArray(location.country_code, UKArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","https://black-blum.com");
            $(".popup-a-data").html("VISIT OUR UK SITE");
            $(".popup-p-data").html("Looks like you’re in<br class='m'> The United Kingdom.<br class='d'> Click below to shop<br class='m'> in your store.");

          }
          else if (jQuery.inArray(location.country_code, DEArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","https://black-blum.de");
            $(".popup-a-data").html("GERMAN SITE");

            $(".popup-a-data-2").attr("style", "display:block");
            $(".popup-a-data-2").attr("href","https://black-blum.eu?shop-eu=true");
            $(".popup-a-data-2").html("EU SITE");

            $(".popup-p-data").html("Looks like you’re in Germany. Click below to shop in your store or shop our EU site to continue in English.");

          }
          else if (jQuery.inArray(location.country_code, FRArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","https://black-blum.eu/fr");
            $(".popup-a-data").html("EU - FRENCH SITE");

            $(".popup-a-data-2").attr("style", "display:block");
            $(".popup-a-data-2").attr("href","https://black-blum.eu?shop-eu=true");
            $(".popup-a-data-2").html("EU - ENGLISH SITE");

            $(".popup-p-data").html("Looks like you’re in France. Click below to shop in your store or shop our EU site to continue in English.");

          }
          else {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("style", "display:none");
            $(".popup-b-data").attr("style", "display:block");
           
            $(".popup-p-data").html("SADLY, WE DON'T SHIP TO YOUR COUNTRY");
            $(".popup-b-data").html("WE SELL OUR DESIGNS IN OVER 60 COUNTRIES, SO PLEASE LOOK ONLINE TO FIND A LOCAL STOCKIST OR ONLINE RETAILER.");
            $(".msg").addClass("msg-div");

          }

        }
        //CHECK GERMANY SITE
        else if (currentSite.indexOf("black-blum.de") > -1 || currentSite.indexOf("black-blum.myshopify.com") > -1) {

          if(jQuery.inArray(location.country_code, DEArray) > -1) {
            
          }
          else if (jQuery.inArray(location.country_code, EUArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","https://black-blum.eu/");
            $(".popup-a-data").html("VISIT OUR EU SITE");
            $(".popup-p-data").html("Looks like you’re not in Germany.<br class='d'> Click below to shop<br class='m'> in your store.");

          }
          else if (jQuery.inArray(location.country_code, FRArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","https://black-blum.eu/fr");
            $(".popup-a-data").html("EU - FRENCH SITE");

            $(".popup-a-data-2").attr("style", "display:block");
            $(".popup-a-data-2").attr("href","https://black-blum.eu?shop-eu=true");
            $(".popup-a-data-2").html("EU ENGLISH SITE");

            $(".popup-p-data").html("Looks like you’re in France. Click below to shop in your store or shop our EU site to continue in English.");

          }
          else if (jQuery.inArray(location.country_code, UKArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","https://black-blum.com");
            $(".popup-a-data").html("VISIT OUR UK SITE");
            $(".popup-p-data").html("Looks like you’re in<br class='m'> The United Kingdom.<br class='d'> Click below to shop<br class='m'> in your store.");

          }
          else if (jQuery.inArray(location.country_code, USAArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","https://blackblum.com/");
            $(".popup-a-data").html("VISIT OUR US SITE");
            $(".popup-p-data").html("Looks like you’re in<br class='m'>  the United States.<br class='d'> Click below to shop<br class='m'> in your store.");

          }
          else if (jQuery.inArray(location.country_code, CAArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","http://black-blum.ca");
            $(".popup-a-data").html("VISIT CANADIAN SITE");
            $(".popup-p-data").html("Looks like you’re in Canada.<br> Click below to visit our official distributor.");

          }
          else {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("style", "display:none");
            $(".popup-b-data").attr("style", "display:block");
           
            $(".popup-p-data").html("SADLY, WE DON'T SHIP TO YOUR COUNTRY");
            $(".popup-b-data").html("WE SELL OUR DESIGNS IN OVER 60 COUNTRIES, SO PLEASE LOOK ONLINE TO FIND A LOCAL STOCKIST OR ONLINE RETAILER.");
            $(".msg").addClass("msg-div");

          }

        }
        //CHECK FRENCH SITE
        else if (currentSite.indexOf("black-blum.eu/fr") > -1 || currentSite.indexOf("blackblum-europe.myshopify.com/fr") > -1) {

          if(jQuery.inArray(location.country_code, FRArray) > -1) {
            
          }
          else if (jQuery.inArray(location.country_code, EUArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","https://black-blum.eu/");
            $(".popup-a-data").html("VISIT OUR EU SITE");
            $(".popup-p-data").html("Looks like you’re not in France.<br class='d'> Click below to shop<br class='m'> in your store.");

          }
          else if (jQuery.inArray(location.country_code, DEArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","https://black-blum.de");
            $(".popup-a-data").html("GERMAN SITE");

            $(".popup-a-data-2").attr("style", "display:block");
            $(".popup-a-data-2").attr("href","https://black-blum.eu?shop-eu=true");
            $(".popup-a-data-2").html("EU SITE");

            $(".popup-p-data").html("Looks like you’re in Germany. Click below to shop in your store or shop our EU site to continue in English.");

          }
          else if (jQuery.inArray(location.country_code, UKArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","https://black-blum.com");
            $(".popup-a-data").html("VISIT OUR UK SITE");
            $(".popup-p-data").html("Looks like you’re in<br class='m'> The United Kingdom.<br class='d'> Click below to shop<br class='m'> in your store.");

          }
          else if (jQuery.inArray(location.country_code, USAArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","https://blackblum.com/");
            $(".popup-a-data").html("VISIT OUR US SITE");
            $(".popup-p-data").html("Looks like you’re in<br class='m'>  the United States.<br class='d'> Click below to shop<br class='m'> in your store.");

          }
          else if (jQuery.inArray(location.country_code, CAArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","http://black-blum.ca");
            $(".popup-a-data").html("VISIT CANADIAN SITE");
            $(".popup-p-data").html("Looks like you’re in Canada.<br> Click below to visit our official distributor.");

          }
          else {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("style", "display:none");
            $(".popup-b-data").attr("style", "display:block");
           
            $(".popup-p-data").html("SADLY, WE DON'T SHIP TO YOUR COUNTRY");
            $(".popup-b-data").html("WE SELL OUR DESIGNS IN OVER 60 COUNTRIES, SO PLEASE LOOK ONLINE TO FIND A LOCAL STOCKIST OR ONLINE RETAILER.");
            $(".msg").addClass("msg-div");

          }

        }
        //CHECK UK SITE
        else if (currentSite.indexOf("black-blum.com") > -1 || currentSite.indexOf("thelodge.myshopify.com") > -1) {

          if(jQuery.inArray(location.country_code, USAArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","https://blackblum.com/");
            $(".popup-a-data").html("VISIT OUR US SITE");
            $(".popup-p-data").html("Looks like you’re in<br class='m'> the United States.<br class='d'> Click below to shop<br class='m'> in your store.");

          }
          else if (jQuery.inArray(location.country_code, CAArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","http://black-blum.ca");
            $(".popup-a-data").html("VISIT CANADIAN SITE");
            $(".popup-p-data").html("Looks like you’re in Canada.<br> Click below to visit our official distributor.");

          }
          else if (jQuery.inArray(location.country_code, EUArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","https://black-blum.eu/");
            $(".popup-a-data").html("VISIT OUR EU SITE");
            $(".popup-p-data").html("Looks like you’re in Europe.<br class='d'> Click below to shop<br class='m'> in your store.");

          }
          else if (jQuery.inArray(location.country_code, DEArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","https://black-blum.de");
            $(".popup-a-data").html("GERMAN SITE");

            $(".popup-a-data-2").attr("style", "display:block");
            $(".popup-a-data-2").attr("href","https://black-blum.eu?shop-eu=true");
            $(".popup-a-data-2").html("EU SITE");

            $(".popup-p-data").html("Looks like you’re in Germany. Click below to shop in your store or shop our EU site to continue in English.");

          }
          else if (jQuery.inArray(location.country_code, FRArray) > -1) {

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("href","https://black-blum.eu/fr");
            $(".popup-a-data").html("EU - FRENCH SITE");

            $(".popup-a-data-2").attr("style", "display:block");
            $(".popup-a-data-2").attr("href","https://black-blum.eu?shop-eu=true");
            $(".popup-a-data-2").html("EU - ENGLISH SITE");

            $(".popup-p-data").html("Looks like you’re in France. Click below to shop in your store or shop our EU site to continue in English.");

          }
          else if(!((jQuery.inArray(location.country_code, UKArray) > -1) || (jQuery.inArray(location.country_code, EUArray) > -1) || (jQuery.inArray(location.country_code, USAArray) > -1) || (jQuery.inArray(location.country_code, CAArray) > -1) || (jQuery.inArray(location.country_code, DEArray) > -1) || (jQuery.inArray(location.country_code, FRArray) > -1) )){

            $(".location").removeClass("dn");
            $(".message").removeClass("dn");

            $(".popup-a-data").attr("style", "display:none");
            $(".popup-b-data").attr("style", "display:block");
           
            $(".popup-p-data").html("SADLY, WE DON'T SHIP TO YOUR COUNTRY");
            $(".popup-b-data").html("WE SELL OUR DESIGNS IN OVER 60 COUNTRIES, SO PLEASE LOOK ONLINE TO FIND A LOCAL STOCKIST OR ONLINE RETAILER.");
            $(".msg").addClass("msg-div");

          }

        } 

      }
    });
  }

  $(".close-popup").click(function(){
    $(".location").hide();
    $(this).closest(".message").hide();
    $.cookie(cookieName, 'true', { expires: 1 });
  });

});